export default __webpack_public_path__ + "static/media/ipl_6.9052a3a1.png";